import { render, staticRenderFns } from "./CustomFieldGroup.vue?vue&type=template&id=5c089d26&"
import script from "./CustomFieldGroup.vue?vue&type=script&lang=js&"
export * from "./CustomFieldGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c089d26')) {
      api.createRecord('5c089d26', component.options)
    } else {
      api.reload('5c089d26', component.options)
    }
    module.hot.accept("./CustomFieldGroup.vue?vue&type=template&id=5c089d26&", function () {
      api.rerender('5c089d26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomFieldGroup.vue"
export default component.exports